import { Button } from './button';
import { Spinner } from './spinner';
import { ButtonHTMLAttributes } from 'react';

interface LoadingButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading: boolean;
  children: React.ReactNode;
}

export function LoadingButton({
  isLoading,
  children,
  ...props
}: LoadingButtonProps) {
  return (
    <Button {...props} disabled={isLoading}>
      {isLoading ? (
        <>
          <Spinner />
          Processando...
        </>
      ) : (
        children
      )}
    </Button>
  );
}
